module.exports = __webpack_public_path__ + "img/select1.2db09f0a.png";